export const RETURN_AIR = "Return Air";
export const SUPPLY_AIR = "Supply Air";
export const OUTSIDE_AIR = "Outside Air";
export const CONFERENCE_ROOM = "Conference Room";
export const OPEN_OFFICE = "Open Office";
export const MIXED_AIR = "Mixed Air";

export const INSTALL_CATEGORIES = [
  RETURN_AIR,
  SUPPLY_AIR,
  OUTSIDE_AIR,
  CONFERENCE_ROOM,
  OPEN_OFFICE,
  MIXED_AIR,
];
